import React, { useState } from "react";

import Paper from "Components/UI/Paper";

//MUI
import { Tab, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import CreateAllMissingInvoices from "./CreateAllMissingInvoices";
import GetInvoiceBundles from "Pages/AdminInterface/files/workflows/GetInvoiceBundles";
import CreateFromAllFiles from "Components/ClientInvoiceBundle/workflows/CreateFromAllFiles";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export default function ClientInvoiceeBundlesWorkflow() {
  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };
  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, pt: 3 }}>
        <Paper elevation={0}>
          <Tabs
            value={tabIndex}
            onChange={handleTabSwitch}
            sx={{ marginBottom: "2rem" }}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label="Hämta fakturabuntar" />
            <Tab label="Skapa fakturabuntar" />

            <Tab label="Skapa fakturor" />
          </Tabs>
          <TabPanel value={tabIndex} index={0} id="tabPanel0">
            <GetInvoiceBundles />
          </TabPanel>
          <TabPanel value={tabIndex} index={1} id="tabPanel0">
            <CreateFromAllFiles />
          </TabPanel>

          <TabPanel value={tabIndex} index={2} id="tabPanel0">
            <CreateAllMissingInvoices />
          </TabPanel>
        </Paper>
      </Box>
    </>
  );
}
